import { createRouter, createWebHistory } from 'vue-router'
import { mustUserLogin } from 'api/user/auth/login';

const Frame = () => import('views_mf/Frame.vue')
const Home = () => import('views_mf/Home.vue')
const AboutUs = () => import('views_mf/AboutUs.vue')
const CertificateQuery = () => import('views_mf/CertificateQuery.vue')
const Training = () => import('views_mf/Training.vue')
const CourseList = () => import('views_mf/course/List.vue')
const CourseDetail = () => import('views_mf/course/Detail.vue')
const CourseTeaching = () => import('views_mf/course/Teaching.vue')
const CourseExercise = () => import('views_mf/course/Exercise.vue')

const Cart = () => import('views_mf/settlement/Cart.vue')
const OrderConfirm = () => import('views_mf/settlement/order/Confirm.vue')
const OrderPay = () => import('views_mf/settlement/order/Pay.vue')
const OrderResult = () => import('views_mf/settlement/order/Result.vue')
const Coupon = () => import('views_mf/settlement/Coupon.vue')

const Center = () => import('views_mf/center/Center.vue')
const CenterAccount = () => import('views_mf/center/Account.vue')
const CenterCourse = () => import('views_mf/center/Course.vue')
const CenterExperiment = () => import('views_mf/center/Experiment.vue')
const CenterCertificate = () => import('views_mf/center/Certificate.vue')
const CenterCode = () => import('views_mf/center/Code.vue')
const CenterCollect = () => import('views_mf/center/Collect.vue')
const CenterOrder = () => import('views_mf/center/Order.vue')
const CenterCard = () => import('views_mf/center/Card.vue')
const CenterTicket = () => import('views_mf/center/Ticket.vue')
const CenterTicketApply = () => import('views_mf/center/TicketApply.vue')

const Agreement = () => import('views_mf/Agreement.vue')
const CustomPage = () => import('views_mf/course/CustomPage.vue')
const EmailActiveResult = () => import('views_mf/EmailActiveResult.vue')
const NotFoundComponent = () => import('views_mf/NotFoundComponent')

const Login = () => import('views_mf/Login.vue')
const LoginSuccess = () => import('views_mf/center/LoginSuccess.vue')

const ZoneDetail = () => import('views_mf/zone/ZoneDetail.vue')

const routes = [
  {
    path: '/mobile',
    redirect: '/mobile/home'
  }, {
    path: '/mobile/login',
    name: 'Login',
    component: Login,
    meta: {
      name: '登录注册'
    }
  }, {
    path: '/mobile',
    name: 'Frame',
    component: Frame,
    children: [{
      path: 'home',
      name: 'Home',
      component: Home,
    },{
      path: 'course/list',
      name: 'CourseList',
      component: CourseList,
    },{
      path: 'course/search',
      name: 'CourseSearch',
      component: CourseList,
    },{
      path: 'course/detail/:uuid',
      name: 'CourseDetail',
      component: CourseDetail,
      meta:['全部课程', '课程详情']
    },{
      path: 'course/detail/:type/:cur_uuid/:uuid',
      name: 'CourseTeaching',
      login: true,
      component: CourseTeaching,
      meta: {
        name: '课程教学',
        login: true
      },
    },{
      path: 'course/exercise/:cur_uuid',
      name: 'CourseExercise',
      login: true,
      component: CourseExercise,
      meta: {
        name: '试题训练',
        login: true
      },
    }, {
      path: 'zone/:zone_domain',
      name: 'ZoneDetail',
      component: ZoneDetail,
      meta: {
        name: '企业专区',
      }
    },{
      path: 'cart',
      name: 'Cart',
      component: Cart,
      meta: {
        name: '购物车',
        login: true
      }
    },{
      path: 'order/confirm/:confirm_key',
      name: 'OrderConfirm',
      component: OrderConfirm,
      meta: {
        name: '订单确认',
        login: true
      }
    },{
      path: 'order/pay/:method?/:order_uuid',
      name: 'OrderPay',
      component: OrderPay,
      meta: {
        name: '订单支付',
        login: true
      }
    },{
      path: 'order/result/:method?/:order_uuid',
      name: 'OrderResult',
      component: OrderResult,
      meta: {
        name: '订单完成',
        login: true
      }
    },{
      path: 'training',
      name: 'Training',
      component: Training,
      meta: {
        name: '企业内训'
      }
    },{
      path: 'aboutus',
      name: 'AboutUs',
      component: AboutUs,
    },{
      path: 'certificatequery',
      name: 'CertificateQuery',
      component: CertificateQuery,
    },{
      path: 'center',
      name: 'Center',
      component: Center,
      login: true,
      meta: {
        name: '个人中心',
        login: true
      }
    },{
      path: 'center/account',
      name: 'CenterAccount',
      component: CenterAccount,
      meta: {
        name: '账号资料',
        login: true
      },
    },{
      path: 'center/ticket',
      name: 'CenterTicket',
      component: CenterTicket,
      meta: {
        name: '我的开票',
        login: true
      },
    },{
      path: 'center/ticket/apply',
      name: 'CenterTicketApply',
      component: CenterTicketApply,
      meta: {
        name: '开票申请',
        login: true
      },
    },{
      path: 'center/code',
      name: 'CenterCode',
      component: CenterCode,
      meta: {
        name: '我的授权码',
        login: true
      },
    },{
      path: 'center/course',
      name: 'CenterCourse',
      component: CenterCourse,
      meta: {
        name: '我的课程',
        login: true
      },
    },{
        path: 'center/certificate',
        name: 'CenterCertificate',
        component: CenterCertificate,
        meta: {
          name: '我的证书',
          login: true
        },
    },{
        path: 'center/experiment',
        name: 'CenterExperiment',
        component: CenterExperiment,
        meta: {
          name: '我的实验',
          login: true
        },
    },{
      path: 'center/collect',
      name: 'CenterCollect',
      component: CenterCollect,
      meta: {
        name: '我的收藏',
        login: true
      },
    },{
      path: 'center/order',
      name: 'CenterOrder',
      login: true,
      component: CenterOrder,
      meta: {
        name: '我的订单',
        login: true
      },
    },{
      path: 'center/card/:tabName?',
      name: 'CenterCard',
      component: CenterCard,
      meta: {
        name: '我的卡包',
        login: true
      },
    },{
      path: 'coupons/issue/:strategy_code?',
      name: 'CouponsIssue',
      component: Coupon,
      meta: {
        name: '链接领取优惠券',
        login: true
      },
    },{
      path: 'agreement',
      name: 'Agreement',
      component: Agreement,
      meta: {
        name: '注册协议'
      }
    },{
      path: 'custom/:nav_url+',
      name: 'CustomPage',
      component: CustomPage,
      meta:['自定义页面']
    },{
      path: 'email/result/:user_id/:captcha',
      name: 'EmailActiveResult',
      component: EmailActiveResult,
      meta:['邮件激活']
    },{
      path: 'login_success/:third_type/:callback_type',
      name: 'LoginSuccess',
      component: LoginSuccess,
      meta:['登陆成功']
    }]
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: NotFoundComponent
  }
]

const router = createRouter({
  history: createWebHistory("/"),
  routes
})

router.beforeEach((to, from, next) => {

  if (!(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))
        && to.fullPath.startsWith('/mobile')) {

    window.location.href = to.fullPath.slice(7);
    return;

  }

  if (to.meta.login) {
    window.need_login = true;
    mustUserLogin().then(res => {
      if (res.result === -1) {
        window.location.href = "/mobile/login/?next=" + to.fullPath;
      } else {
        next()
      }
    })
  } else {
    window.need_login = false;
    next()
  }
})

export default router
